import Big from 'big.js'

import type {FoodGrubhubCartItem} from '@/lib/food-grubhub/foodGrubhubCartDb'
import type {
  ChoiceCategoryList,
  MenuItemDetails,
} from '@/lib/food-grubhub/foodRestaurantDetailModel'

import flattenSelectedOptions from './flattenSelectedOptions'

export default function getPrice(
  menuItemDetail: MenuItemDetails | undefined,
  selectedOptions: FoodGrubhubCartItem['options'] | undefined,
) {
  let price = Big(menuItemDetail?.price?.amount ?? 0).div(100)

  const flattenedSelectedOptionsMap = flattenSelectedOptions(selectedOptions)

  function traverseChoiceCategories(choiceCategories: ChoiceCategoryList[] | undefined | null) {
    choiceCategories?.forEach(category => {
      category.choice_option_list?.forEach(option => {
        const selectedOption = flattenedSelectedOptionsMap.get(option.id ?? '')
        if (selectedOption && selectedOption.quantity !== 0) {
          const optionPrice = option.price?.amount ?? 0
          price = price.plus(Big(optionPrice).div(100).times(selectedOption.quantity))
        }

        if (option.choice_category_list) {
          traverseChoiceCategories(option.choice_category_list)
        }
      })
    })
  }

  traverseChoiceCategories(menuItemDetail?.choice_category_list)

  return price
}
